module.exports = __webpack_public_path__ + "img/icon2.cf62b78a.png";